import { TranslationMap } from '@trimble-gcs/i18n-types';

export function dialogTranslations() {
  return {
    close: {
      tooltip: {
        text: $localize`:@@dialog.close.tooltip:Close`,
        desc: "Tooltip for the 'Close' button in dialog boxes. ",
      },
    },
    cancelButton: {
      text: $localize`:@@dialog.cancel.button:Cancel`,
      desc: "Button text for the 'Cancel' button in dialog boxes. ",
    },
    okButton: {
      text: $localize`:@@dialog.ok.button:OK`,
      desc: "Button text for the 'OK' button in dialog boxes. ",
    },
  } satisfies TranslationMap;
}
